<template>
  <div>
    <Modal v-model="modalShow" :title="$t('Emp_Ach_mess25')" width="80%">
      <Form inline label-position="left" :label-width="80">
        <Row :gutter="10">
          <Col span="5">
            <FormItem :label="$t('Employee_Code')">
              <!-- 员工号 -->
              <Input v-model="formItem.empCode" disabled></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label="$t('Name')"
              ><!-- 员工姓名 -->
              <Input
                v-model="formItem.userName"
                disabled
                v-if="lang == 'zh'"
              ></Input>
              <Input v-model="formItem.userEName" disabled v-else></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table border :loading="loading" :columns="columns" :data="data"> </Table>
      <div style="margin:20px 0;display:flex;justify-content: flex-end;">
        <Page :total="total" @on-change="pageChange" />
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      formItem: {},
      modalShow: false,
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      applyPbId: "",
      data: []
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Emp_Ach_mess24") /* 审批人姓名 */,
          key: this.lang == "zh" ? "userName" : "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Approval_Decision") /* 审批决定 */,
          key: "decision",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
          key: this.lang == "zh" ? "whatScore" : "enWhatScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
          key: this.lang == "zh" ? "howScore" : "enHowScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
          key: this.lang == "zh" ? "wholeScore" : "enWholeScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Potential_Rating") /* 潜能评分 */,
          key: this.lang == "zh" ? "potentialScore" : "enPotentialScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Remarks") /* 备注 */,
          key: "comment",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Approval_Time") /* 审批时间 */,
          key: "createTime",
          align: "center",
          minWidth: 160
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  created() {},
  methods: {
    getData() {
      this.loading = true;
      axios
        .post("/AchPeopleBoard/selectPBApprovalList", {
          ...this.pageInfo,
          applyPbId: this.formItem.applyPbId
        })
        .then(res => {
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
          this.loading = false;
        });
    },

    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/PerformanceEvaluationModal.vue